const isVideoPlaying = (video) =>
  video &&
  !(
    video.paused ||
    video.ended ||
    video.seeking ||
    video.readyState < video.HAVE_FUTURE_DATA
  )
export { isVideoPlaying }
